"use client";
import Button from "@/components/Cards/Button";
import { TextInput } from "@/components/Inputs/TextInput";
import InfoModal from "@/components/Modal";
import Text from "@/components/Text/Text";
import { ButtonDark } from "@/stories/Button.stories";
import { Checkbox } from "@mantine/core";
import { useForm, zodResolver } from "@mantine/form";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { z } from "zod";
import BackButton from "../BackButton";
import ErrorModal from "../ErrorModal";

export default function TageGeldZuruckGarantieLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);
    const schema = z.object({
        msg: z.string(),
        apply: z.boolean(),
        andrede: z.string(),
        name: z.string(),
        surname: z.string(),
        email: z
            .string()
            .email()
            .refine((value) => value.length > 0, {
                message: "Bitte gib eine gültige E-Mail-Adresse ein.",
            }),
    });
    const form = useForm({
        initialValues: {
            msg: "",
            apply: false,
            andrede: "",
            name: "",
            surname: "",
            email: "",
        },
        validate: zodResolver(schema),
    });
    const router = useRouter();

    return (
        <>
            <div className="container  z-10 max-w-10xl px-3 lg:mx-auto py-40 space-y-5 lg:space-y-10">
                <BackButton link={"/book-now"} />
                <h1 className=" text-black text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14">
                    I'd like to apply for the 30-day money back guarantee
                </h1>
                <div className="text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    If the remote treatment isn't working out for you, you can request a
                    refund without needing to explain why.
                </div>

                <div className=" text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    The money-back guarantee can be used once per person within the first
                    30 days of starting the remote treatment.
                </div>
                <div className="text-black text-2xl font-bold  leading-7 lg:leading-loose">
                    Please keep in mind:
                </div>
                <div className="text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                    <li>
                        When you submit this form, the remote treatment will end right
                        away.
                    </li>
                </div>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            paddings=""
                            title={
                                "Thank you for reaching out about the 30-day money back guarantee"
                            }
                            paragraphs={[
                                "Thank you for your message.",
                                "We're currently looking into your request for a refund and will get back to you soon",
                                "Best regards",
                                "Support Team of Rico Brunner",
                            ]}
                        />

                        <div className="flex py-5 justify-end">
                            <Button
                                size={ButtonDark.args?.size}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={ButtonDark.args?.hasIcon}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                as="a"
                                href={"/"}
                            />
                        </div>
                    </>
                </InfoModal>
                <form
                    className="space-y-3"
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            msg: values.msg,
                            apply: values.apply,
                            andrede: values.andrede,
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                        };

                        sendEmail("30-Tage-Geld-zurück-Garantie beantragen", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch((e) => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                    })}
                >
                    <div>
                        <TextInput
                            id="msg"
                            name="msg"
                            type="textarea"
                            label={"Your message"}
                            {...form.getInputProps("msg")}
                        />
                    </div>
                    <Checkbox
                        id="apply"
                        name="apply"
                        label={"Requesting a 30-day money-back guarantee"}
                        className="text-neutral-800 text-base font-bold  leading-tight"
                        {...form.getInputProps("apply")}
                    />

                    <TextInput
                        id="name"
                        name="name"
                        type="text"
                        label={"First name"}
                        placeholder={"enter here"}
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        id="surname"
                        name="surname"
                        type="text"
                        label={"Last name"}
                        placeholder={"enter here"}
                        {...form.getInputProps("surname")}
                    />

                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        label={"Email Address"}
                        placeholder={"enter here"}
                        {...form.getInputProps("email")}
                    />
                    <Button
                        backgroundColor={ButtonDark.args?.backgroundColor}
                        hasIcon={ButtonDark.args?.hasIcon}
                        text={"CLAIM NOW"}
                        size={ButtonDark.args?.size}
                        paddings={ButtonDark.args?.paddings}
                        buttonType="submit"
                    />

                    <div className="text-black text-base font-normal  leading-tight">
                        Your information will be kept confidential.
                    </div>
                </form>
            </div>
        </>
    );
}
